import React from 'react';
import './styles.scss';

import logo from '../../icons/logo.png';
import googlePlayIcon from '../../icons/google-play-badge.png';
import appstoreIcon from '../../icons/appstore-badge.png';
import instaIcon from '../../icons/insta.svg';
import fbIcon from '../../icons/facebook.svg';
import twitterIcon from '../../icons/twitter.svg';
import {
    ABOUT_URL,
    STORIES_OF_IMPACT_URL,
    HOW_IT_WORKS_URL,
    MAPS_URL,
    BECOME_PARTNER_URL,
    TERMS_AND_CONDITIONS_URL,
    PRIVACY_POLICY_URL,
    TWITTER_URL,
    INSTAGRAM_URL,
    FACEBOOK_URL,
    IOS_APP_URL,
    ANDROID_APP_URL,
} from './../constants';

function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-2">
                        <img src={logo} width={125} />
                    </div>
                    <div className="col-md-7">
                        <div className="row justify-content-md-end">
                            <a className="margin-left-8" href={IOS_APP_URL}>
                                <img src={appstoreIcon} width={135} />
                            </a>
                            <a
                                className="margin-left-20"
                                href={ANDROID_APP_URL}
                            >
                                <img src={googlePlayIcon} width={135} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-between links pr-2 pl-2">
                    <div className="col-md-6">
                        <div className="row justify-content-between">
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={ABOUT_URL}
                            >
                                {' '}
                                About{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={STORIES_OF_IMPACT_URL}
                            >
                                {' '}
                                Stories of Impact{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={HOW_IT_WORKS_URL}
                            >
                                {' '}
                                How it Works{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={MAPS_URL}
                            >
                                {' '}
                                Map{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={BECOME_PARTNER_URL}
                            >
                                {' '}
                                Become a Partner{' '}
                            </a>
                        </div>
                    </div>

                    <div className="col-md-5">
                        <div className="row justify-content-between">
                            <span className="copyright">
                                {' '}
                                &copy; 2020 Litterati{' '}
                            </span>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={TERMS_AND_CONDITIONS_URL}
                            >
                                {' '}
                                Terms{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={PRIVACY_POLICY_URL}
                            >
                                {' '}
                                Privacy{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={TWITTER_URL}
                            >
                                {' '}
                                <img src={twitterIcon} width={24} />{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={FACEBOOK_URL}
                            >
                                {' '}
                                <img src={fbIcon} width={24} />{' '}
                            </a>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={INSTAGRAM_URL}
                            >
                                {' '}
                                <img src={instaIcon} width={24} />{' '}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
